module.exports = __webpack_public_path__ + "media/assets/images/authors/damiano_cavazzana-1b9c1515e9c768709b0bfc2eeb23c0e7.jpg";